<template>
  <div>
    <v-card>
      <!-- search -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <div class="d-flex align-center pb-5">
          <h1>Add Ons</h1>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center pb-5">
          <v-text-field
            v-model="searchQuery"
            single-line
            dense
            outlined
            hide-details
            placeholder="Buscar"
            class="me-3"
          ></v-text-field>
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="text-no-wrap"
      >
        <!-- CreationDate -->
        <template #[`item.createdOn`]="{ item }">
          {{ item.createdOn | date }}
        </template>
        <!-- Price -->
        <template #[`item.amount`]="{ item }">
          {{ item.amount | currency }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>

// composition function
import { ref, watch } from '@vue/composition-api'
import store from '@/store'

export default {
  setup() {
    const items = ref([])

    // Table Handlers
    const headers = [
      { text: '#ID', align: 'start', value: 'addOnId' },
      { text: 'ID Cita', value: 'bookingId' },
      { text: 'Nombre', value: 'name' },
      { text: 'Importe', value: 'amount' },
      { text: 'Cantidad', value: 'quantity' },
      { text: 'Id De Usuario', value: 'userId' },
      { text: 'Creado El', value: 'createdOn' },
    ]

    const searchQuery = ref('')
    const options = ref({
      sortBy: [],
      sortDesc: [],
    })
    const totalItems = ref(0)
    const loading = ref(false)
    const isAddEditSidebarActive = ref(false)

    const FetchItems = () => {
      loading.value = true
      store
        .dispatch('addOns/apiCall', {
          mode: 'select',
          request: {
            q: searchQuery.value,
            srt: options.value.sortBy,
            desc: options.value.sortDesc,
            pg: options.value.page - 1,
            ippg: options.value.itemsPerPage,
            all: process.env.VUE_APP_API_ALL,
          },
        })
        .then(response => {
          if (response.success) {
            items.value = response.data.items
            totalItems.value = response.data.total
          }
        })
        .finally(() => {
          loading.value = false
        })
    }

    watch([searchQuery], () => {
      options.value.page = 1
      FetchItems()
    })

    watch([options], () => {
      FetchItems()
    })

    return {
      headers,
      searchQuery,
      options,
      totalItems,
      items,
      loading,
      isAddEditSidebarActive,
      FetchItems,
    }
  },
}
</script>
